export const exportJson = (data: any, fileName: string) => {
  const content = JSON.stringify(data);
  const blob = new Blob([content], {
    type: "application/json",
  });
  const href = URL.createObjectURL(blob);

  const link = document.createElement("a");
  link.href = href;
  link.download = fileName + ".json";
  document.body.appendChild(link);
  link.click();

  document.body.removeChild(link);
  URL.revokeObjectURL(href);
};
